import { AdminAllowanceNames, ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import strings from '../../../localization';
import { nameLabels } from '../../../helpers/Constants';
import { pharmacyRateKey } from '../ApproveBooking/helper';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

export const config = () =>
  (isSelfService
    ? [
      {
        key: '1',
        name: AdminAllowanceNames.pharmacistHourlyRate,
        label: strings.formatString(strings.hourlyRateFormat, strings.professional) as string,
      },

    ]
    : [
      {
        key: '1',
        name: AdminAllowanceNames.pharmacistHourlyRate,
        label: strings.formatString(strings.hourlyRateFormat, strings.professional) as string,
      },
      {
        key: pharmacyRateKey,
        name: AdminAllowanceNames.pharmacyHourlyRate,
        label: strings.pharmacyHourlyRate,
      },
    ]);

export const checkboxConfig = () =>
  [
    {
      key: '1',
      name: 'sendEmailToPharmacist',
      label: strings.formatString(
        strings.sendEmailNotification,
        nameLabels().roleLabel,
      ) as string,
    },
    {
      key: '2',
      name: 'sendEmailToPharmacy',
      label: strings.formatString(
        strings.sendEmailNotification,
        strings.pharmacy,
      ) as string,
    },
  ];

export const notesConfig = (isLongTerm: boolean) => {
  const notes = [];

  if (isLongTerm) {
    notes.push({
      key: '1',
      name: 'allowanceNotes',
      label: strings.allowances,
    });
  } else {
    notes.push({
      key: '2',
      name: 'notes',
      label: strings.notes,
    });
  }

  if (!isSelfService) {
    notes.push({
      key: '1',
      name: 'notesForSalesOrder',
      label: strings.notesForSalesOrder,
    });
  }

  return notes;
};
